import { Component } from '@angular/core';
import { PanAppState } from '@panamax/app-state';
import { take } from 'rxjs/operators';
import { FEATURES } from '../shared/constants/splitio-features';

@Component({
  selector: 'app-feature-demo',
  templateUrl: './feature-demo.page.html',
  styleUrls: ['./feature-demo.page.scss'],
})
export class FeatureDemoPage {
  demoUserTrafficTypeFlag = FEATURES.demo_user_trafic_type_feature.name;
  demoUserTrafficType2Flag = FEATURES.demo_user_trafic_type_feature2.name;
  demoUserTrafficType3Flag = FEATURES.demo_user_traffic_type_feature3.name;

  demoDivisionTrafficTypeFlag =
    FEATURES.demo_division_traffic_type_feature.name;
  demoDivisionTrafficType2Flag =
    FEATURES.demo_division_traffic_type_feature2.name;

  demoCustomerTrafficTypeFlag =
    FEATURES.demo_customer_traffic_type_feature.name;
  demoCustomerTrafficType2Flag =
    FEATURES.demo_customer_traffic_type_feature2.name;

  constructor(readonly panAppState: PanAppState) {
    this.panAppState
      .feature$([FEATURES.split_global_legacy_login.name])
      .pipe(take(1))
      .subscribe(on => {
        if (on) {
          console.log('feature is on.');
        } else {
          console.log('feature is off.');
        }
      });
  }
}
